import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'

import { cn } from '@/lib/utils'

const badgeVariants = cva(
  'inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2',
  {
    variants: {
      variant: {
        default:
          'border-transparent bg-accent-1 text-white hover:bg-accent-1/80',
        secondary:
          'border-transparent bg-monochrome-120 text-white hover:bg-monochrome-120/80',
        destructive:
          'border-transparent bg-accent-3 text-white hover:bg-accent-3/80',
        outline: 'text-foreground',
        success:
          'border-transparent bg-accent-1 text-white hover:bg-accent-1/80',
        warning:
          'border-transparent bg-accent-3 text-white hover:bg-accent-3/80',
        danger:
          'border-transparent bg-accent-3 text-white hover:bg-accent-3/80',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
